import axios, { AxiosInstance, InternalAxiosRequestConfig, AxiosResponse } from "axios"

import { useAuthStore } from "@store"
import { API_URL } from "@src/config/environments"

// Create axios instance
const api: AxiosInstance = axios.create({
  baseURL: API_URL,
  // timeout: 10000,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
})

// Request interceptor to add auth token
api.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    const { token } = useAuthStore.getState() || {}
    if (token && config.headers) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  },
)

// Response interceptor to handle auth errors
api.interceptors.response.use(
  (response: AxiosResponse) => {
    return response
  },
  (error) => {
    if (error.response?.status === 401) {
      useAuthStore.getState().logout(true)
      if (error.response?.config?.url !== "/auth/login") {
        window.location.href = "/login"
      }
    }
    return Promise.reject(error)
  },
)

export default api
